<template>
  <v-app>
    <!-- Skip-to-content link: first focusable element for keyboard users (Req 9.5) -->
    <a class="skip-to-content" href="#main-content">Skip to content</a>

    <!-- Persistent navigation on every page (Req 1.4) -->
    <header>
      <NavigationBar />
    </header>

    <!-- Primary landmark; target of the skip link (Req 9.2, 9.5) -->
    <main id="main-content" tabindex="-1">
      <router-view />
    </main>

    <!-- Footer on every page (Req 1.7) -->
    <footer>
      <SiteFooter />
    </footer>
  </v-app>
</template>

<script>
import NavigationBar from 'components/NavigationBar.vue';
import SiteFooter from 'components/SiteFooter.vue';

export default {
  name: 'App',
  components: {
    NavigationBar,
    SiteFooter,
  },
};
</script>

<style>
/*
 * Skip-to-content link: visually hidden until focused, then revealed at the
 * top-left so keyboard users can jump straight to the main content (Req 9.5).
 */
.skip-to-content {
  position: absolute;
  left: -9999px;
  top: 0;
  z-index: 2000;
  padding: 0.75rem 1rem;
  background: #e7511e;
  color: #ffffff;
  font-weight: 700;
  text-decoration: none;
  border-radius: 0 0 4px 0;
}

.skip-to-content:focus {
  left: 0;
}

/* Ensure the main landmark does not show a default focus outline when
   focused programmatically via the skip link, while remaining keyboard
   reachable. */
#main-content:focus {
  outline: none;
}
</style>
